import { FC } from 'react';

import { IRewardText } from './types';

export const RewardText: FC<React.PropsWithChildren<IRewardText>> = () => null;
